import { createContext } from 'react';
import { decorate, observable, action } from 'mobx';

import * as fn from '../utilities/_functions';
import api from '../api';

export class AppointmentGroup {
    id = null;
    data = {
        appointment: null,
        suggestions: []
    };
    groupWithIds = [];
    isReady = false;
    hasUnsavedChanges = false;
    isSaving = false;
    cancelAppointmentCreate = null;

    initialize = (id, suggestions) => {
        const that = this;

        that.clear();
        that.id = id;

        const requests = [api.Appointments.get(id)];

        if (fn.isNullOrUndefined(suggestions)) {
            requests.push(api.Appointments.groupSuggestions(id));
        }
        else {
            that.data.suggestions = suggestions;
            that.groupWithIds = suggestions && suggestions.length > 0 ? suggestions.map(s => { return s.id }) : [];
        }

        return new Promise((resolve, reject) => {
            Promise.all(requests)
                .then(response => {
                    if (response) {
                        that.data.appointment = response[0].data ? response[0].data : null;

                        if (response.length > 1) {
                            that.data.suggestions = response[1].data;
                            that.groupWithIds = response[1].data.map(s => { return s.id });
                        }
                    }
                    resolve();
                })
                .catch(() => {
                    reject();
                })
                .finally(() => {
                    that.isReady = true;
                })
        })
    }

    save = (notify) => {
        const that = this;

        if (!!notify) {
            this.isSaving = true;
        }

        return new Promise((resolve, reject) => {
            api.Appointments.group(that.id,
                { appointmentIds: that.groupWithIds },
                (c) => { that.cancelAppointmentCreate = c }
            )
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(() => {
                    reject();
                })
                .finally(() => {
                    that.cancelAppointmentCreate = null;
                    that.isSaving = false;
                    that.hasUnsavedChanges = false;
                })
        })
    }

    clear = () => {
        this.id = null;
        this.data.appointment = null;
        this.data.suggestions.clear();
        this.groupWithIds.clear();
        this.hasUnsavedChanges = false;
        this.isReady = false;
        this.isSaving = false;
        if (fn.isFunction(this.cancelAppointmentCreate)) {
            this.cancelAppointmentCreate();
            this.cancelAppointmentCreate = null;
        }
    }
}

decorate(AppointmentGroup, {
    id: observable,
    data: observable,
    groupWithIds: observable,
    isReady: observable,
    isSaving: observable,
    initialize: action,
    save: action,
    clear: action,
})

export default createContext(new AppointmentGroup());
